import { IsDevEnv } from '../../Settings'
import { testerOptions, testers } from '../testers'
import { fields, form, zodValidator } from '@codeleap/form'
import z from 'zod'
import { LocalStorage } from '../../localStorage'
import { t } from '@lingui/core/macro'

const currentTester = LocalStorage.getItem('TESTER') ?? 'default'

const initialState = IsDevEnv ? testers.default : undefined

export const login = form('login', {
  email: fields.text({
    placeholder: 'email@example.com',
    label: 'Email address',
    validate: zodValidator(z.string().min(1).email()),
    defaultValue: initialState?.email,
  }),
  password: fields.text({
    password: true,
    label: t`Password`,
    placeholder: t`My secret password`,
    validate: zodValidator(z.string().min(6).max(128)),
    defaultValue: initialState?.password,
  }),
  remember: fields.boolean({
    label: t`Remember information`,
    defaultValue: false,
    onValueChange(newValue) {
      // APIClient.Session.toggleRememberInformation(newValue)
    },
  }),
  tester: fields.selectable({
    label: 'Tester',
    options: testerOptions,
    defaultValue: currentTester,
    onValueChange: (to) => LocalStorage.setItem('TESTER', to)
  })
})